import React, { forwardRef } from 'react';

export const Separator = forwardRef<HTMLDivElement, { mode: string }>(({ mode }, ref) => (
  <div ref={ref} className={`cds-section cds-section--${mode || 'transparent'}-mode separator`}>
    <hr className="separator__line" />
  </div>
));
